import React, { FC, PropsWithChildren } from 'react';
import { styled } from 'linaria/react';
const Description: FC<PropsWithChildren> = ({
  children
}) => <DescriptionWrapper>{children}</DescriptionWrapper>;
export default Description;
const DescriptionWrapper = /*#__PURE__*/styled('p')({
  name: "DescriptionWrapper",
  class: "d8uka1r",
  propsAsIs: false
});

require("./Description.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Description.tsx");